<!-- 商品链接复制弹窗 -->
<template>
	<el-dialog width="600px" :modal-append-to-body='false' :close-on-click-modal="false" :visible.sync="isShowDialog" :before-close='closeDialog'>
		<el-form class="trade-again-box">
			<div class="trade-again-title">{{ $t('goods.GoodsLinkCopyDialog.348313-0') }}</div>
			<el-form-item>
				<div class="link-goods-name">{{goodsInfo.goodsName}}</div>
				<div class="link-url" v-if="pcLinkUrl">
					<span class='url-content'>{{ $t('goods.GoodsLinkCopyDialog.348313-4', [pcLinkUrl]) }}</span>
				</div>
				<div class="link-url" v-if="minAppLinkUrl">
					<span class='url-content'>{{ $t('goods.GoodsLinkCopyDialog.348313-5', [minAppLinkUrl]) }}</span>
				</div>
			</el-form-item>
			<el-form-item class="trade-again-btns">
				<el-button class="copy-btn" @click="copyLink">{{ $t('common.action.copy') }}</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
	import {
		getMinAppShotLinkForGoodsDetail
	} from '../../utils/api-utils/api-wxplat.js'

	// 内部域名
	const innerDomianList = ["jmall.jackyun.com", "home.es86.com:3008", "localhost:1500"];

	export default {
		name: 'goods-link-copy-dialog',
		props: {
			// 是否展示弹窗
			isShow: {
				type: Boolean,
				default: false
			},
			// 商品信息
			goodsInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				isShowDialog: false, // 是否展示弹窗
				pcLinkUrl: "", // PC端链接地址
				minAppLinkUrl: "", // 小程序端链接地址
			}
		},
		watch: {
			isShow: {
				handler(newVal, oldVal) {
					this.isShowDialog = newVal
				},
				immediate: true
			}
		},
		mounted() {
			// 生成链接地址
			this._generateUrl();
		},
		methods: {
			/**
			 * 关闭弹窗
			 */
			closeDialog() {
				// 调用父级确认方法
				this.$emit('close');
			},

			/**
			 * 生成链接地址
			 */
			_generateUrl() {
				// PC端
				// 获取当前域名
				let domianName = location.host;
				// 用户来源域名
				let userRef = localStorage.getItem("userRef") || "";
				console.log("来源域名：" + userRef);
				// 内部域名，直接复制当前地址
				if (!userRef) {
					this.pcLinkUrl = location.href;
				} else {
					switch (this.goodsInfo.actType) {
						// 抢购详情
						case 1:
							this.pcLinkUrl = `${userRef}?t=tgd&gid=${this.goodsInfo.goodsId}&aid=${this.goodsInfo.actId}`;
							break;
							// 商品详情
						default:
							this.pcLinkUrl = `${userRef}?t=gd&gid=${this.goodsInfo.goodsId}`;
							break;
					}
				}

				// 小程序
				getMinAppShotLinkForGoodsDetail(this.goodsInfo.goodsId, this.goodsInfo.goodsName).then((shotLink) => {
					this.minAppLinkUrl = shotLink;
				});
			},

			/**
			 * 复制链接
			 */
			copyLink() {
				// 复制内容
				let textArr = [
					this.goodsInfo.goodsName
				];
				if (this.pcLinkUrl) {
					textArr.push(this.$t('goods.GoodsLinkCopyDialog.348313-4', [this.pcLinkUrl]));
				}
				if (this.minAppLinkUrl) {
					textArr.push(this.$t('goods.GoodsLinkCopyDialog.348313-5', [this.minAppLinkUrl]));
				}

				// 复制
				this._copyTextToClipboard(textArr.join('\n'));
			},

			/**
			 * 复制纯文本（支持换行）
			 * @param {Object} text
			 */
			_copyTextToClipboard(text) {
				// 创建一个临时的textarea元素
				let textarea = document.createElement('textarea');
				textarea.value = text;
				textarea.style.position = 'fixed'; // 避免滚动到页面底部
				document.body.appendChild(textarea);
				textarea.select();

				try {
					let successful = document.execCommand('copy');

					if (successful) {
						this.$message.success(this.$t('goods.GoodsLinkCopyDialog.348313-6'));
					} else {
						this.$message.error(this.$t('goods.GoodsLinkCopyDialog.348313-7'));
					}
				} catch (err) {
					this.$message.error(this.$t('goods.GoodsLinkCopyDialog.348313-8'));
				}

				document.body.removeChild(textarea);
			}
		},
	}
</script>

<style scoped="scoped">
	.trade-again-box {
		padding: 0 25px;
	}

	.trade-again-title {
		text-align: center;
		font-size: 22px;
		margin-bottom: 20px;
	}

	.trade-again-btns {
		text-align: center;
		margin: 35px auto 0;
	}

	.el-dialog__headerbtn {
		font-size: 24px !important;
	}

	.link-goods-name {
		font-size: 17px;
		line-height: 26px;
		word-break: break-all;
		color: #444;
		font-weight: bold;
	}

	.link-url {
		line-height: 24px;
		font-size: 17px;
		margin-top: 15px;
		font-weight: unset;
	}

	.link-url .url-content {
		color: #444;
	}

	.copy-btn {
		width: 115px;
	}
</style>